:host {
  /** @prop --button-offset: offset between button and progress bar */
  --button-offset: var(--wb-spacing-xs);

  display: inline-flex;
  flex-direction: column;
  align-items: center;
}

.wb-text {
  color: var(--wb-grey-45);
  margin-block-end: var(--wb-spacing-xxs);
}

.wb-progress {
  max-width: 120px;
  margin-block-end: var(--button-offset);
}

:host([theme='dark']) .wb-text {
  color: var(--wb-white);
}
